export default __webpack_public_path__ + "static/media/github-background-dark.0ee6dec4.svg";